import { styled } from 'styled-components';

/** Truncate overflowing text with ellipsis */
const Truncate = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  max-width: 100%;
`;

export default Truncate;
